var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-sm-flex my-sm-2 my-4"},[_c('label',{staticClass:"col-sm-2 text-sm-right gl-font-weight-bold gl-pl-0"},[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 gl-pl-0 gl-text-gray-500"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }